import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateLock, Lock, LockListResponse, LockQueryParams } from '@frontend/import/types';

export class LockClient extends APIClient {
    public static readonly endpoint = '/import-api/v1';

    public static async fetchLocks(queryParams?: ApiQueryParams<LockQueryParams>): Promise<LockListResponse> {
        return await this.apiPaginated<LockListResponse, LockQueryParams>(`${this.endpoint}/locks`, queryParams);
    }

    public static async resolveLocks(ids: string[]): Promise<LockListResponse> {
        const response = await this.post(`${this.endpoint}/locks-resolve`, { ids: ids });
        return await this.handleResponse<LockListResponse>(response);
    }

    public static async deleteLocks(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/locks-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postLock(accountId: string, jobId: string, body: CreateLock): Promise<Lock> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/jobs/${jobId}/locks`, body);
        return await this.handleResponse<Lock>(response);
    }

    public static async fetchLock(accountId: string, jobId: string, lockId: string): Promise<Lock> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/jobs/${jobId}/locks/${lockId}`);
        return await this.handleResponse<Lock>(response);
    }

    public static async deleteLock(accountId: string, jobId: string, lockId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/jobs/${jobId}/locks/${lockId}`);
        return await this.handleVoidResponse(response);
    }
}
